'use client'

import { useEffect } from 'react'

import Box from '@mui/material/Box'

import Divider from '@mui/material/Divider'

import { useUIStore } from '@/stores/uiStore'

import {
  pendapatanItems,
  perawatanItems,
  sdpMenuItems,
  tmcMenuItems,
  operasiItems,
  rekamMedisItems
} from '../../types/menuData'

import MenuSection from './MenuSection'

// ─── HomeMenu Component ──────────────────────────────────────────────────────

const HomeMenu = () => {
  const selectedUsaha = useUIStore(state => state.selectedUsaha)
  const hydrate = useUIStore(state => state.hydrateFromStorage)

  // Hydrate store on mount
  useEffect(() => {
    hydrate()
  }, [hydrate])

  if (selectedUsaha === 'TMC') {
    return (
      <Box>
        {/* Main Menu Items (TMC) */}
        <MenuSection title='Kunjungan' items={tmcMenuItems} />
        <MenuSection title='Pelayanan' items={perawatanItems} />
        <MenuSection title='Biaya & Pendapatan' items={pendapatanItems} />
        <MenuSection title='Operasi' items={operasiItems} />
        <MenuSection title='Rekam Medis' items={rekamMedisItems} />

        {/* <MenuSection title='Biaya' items={biayaItems} /> */}

        <Divider sx={{ marginTop: '8px', marginBottom: '8px', borderWidth: '1px' }} />
      </Box>
    )
  } else if (selectedUsaha === 'SDP') {
    return (
      <Box>
        {/* Main Menu Items (SDP) */}
        <MenuSection title='Report' items={sdpMenuItems} />
      </Box>
    )
  }

  return null
}

export default HomeMenu
